/**
 * BracketsToggleSection - Tournament brackets toggle with editor link
 * Extracted from EventsTab.jsx
 */
import { Link } from "react-router-dom";
import { GitBranch } from "lucide-react";

export const BracketsToggleSection = ({ formData, setFormData, editingEvent }) => (
  <div className="p-4 bg-zinc-800/50 border border-white/5">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <GitBranch className="w-5 h-5 text-yellow-500" />
        <div>
          <h4 className="font-secondary text-sm font-bold uppercase text-white">Tournament Brackets</h4>
          <p className="text-xs text-zinc-500">Enable brackets for this event (configure after saving)</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <label className="flex items-center gap-2 cursor-pointer">
          <input 
            type="checkbox" 
            checked={formData.brackets_enabled}
            onChange={(e) => setFormData({...formData, brackets_enabled: e.target.checked})}
            className="w-4 h-4"
            disabled={formData.event_type === 'all_star'}
          />
          <span className="text-sm text-zinc-400">Enable</span>
        </label>
        {editingEvent && formData.brackets_enabled && (
          <Link
            to={`/admin/event/${editingEvent}/brackets`}
            className="flex items-center gap-2 px-3 py-1.5 bg-yellow-600 hover:bg-yellow-500 text-black text-xs font-bold uppercase rounded transition-colors"
            data-testid="bracket-editor-btn"
          >
            <GitBranch className="w-3 h-3" />
            Bracket Editor
          </Link>
        )}
      </div>
      {formData.event_type === 'all_star' && (
        <p className="text-[10px] text-zinc-600 mt-1">Brackets are not available for All-Star games</p>
      )}
    </div>
  </div>
);

export default BracketsToggleSection;
